module.exports = __webpack_public_path__ + "img/diamondsAsSaving.017ba72.webp";